export const systems = [
  {
    name: 'Semantic Knowledge Platform',
    tagline: 'Connecting, organizing, and governing knowledge across research and institutions.',
    link: '/semantic-knowledge',
    linkLabel: 'Explore SKP',
    paragraphs: [
      'The Semantic Knowledge Platform (SKP) turns scattered information into connected knowledge. It organizes concepts and relationships, preserves supporting sources, and combines expert review with semantic search and AI assisted discovery.',
      'In scientific research, an AI assistant could propose connections among organisms, conditions, interventions, study populations, and outcomes. Each proposal would link to a supporting passage, match terms to approved concepts, and pass through validation and review. Approved relationships would become part of a knowledge graph that researchers can explore and build upon.',
      'SKP also provides the knowledge foundation for SyNeural’s other work. It connects capability definitions, assessment methods, interpretation rules, learning activities, policies, and role requirements while preserving their sources and versions.',
    ],
    note: '',
  },
  {
    name: 'Human Capability Framework',
    tagline: 'Developing reasoning, judgment, and readiness for responsibility.',
    link: '/human-capability',
    linkLabel: 'Explore the framework',
    paragraphs: [
      'The Human Capability Framework brings together the Civic Judgment Index (CJI) and Neurocognitive Civic Judgment Index (NCJI) with methods for assessment, interpretation, and development, along with development pathways and supporting services.',
      'These frameworks explore reasoning, consequential thinking, manipulation resistance, self-direction, cooperation, and leadership responsibility. Their purpose is to connect findings with practical next steps: explain a capability gap, support improvement, reassess progress, and identify appropriate opportunities.',
    ],
    note: 'Assessment methods must be validated for their intended uses. A framework for capability development does not automatically establish suitability for hiring, clinical diagnosis, or other consequential decisions.',
  },
  {
    name: 'Noetivra',
    tagline: 'Connected knowledge. Clear insight. Intuitive control.',
    link: '/noetivra',
    linkLabel: 'Explore Noetivra',
    paragraphs: [
      'Noetivra provides domain-specific interactive workspaces for exploring knowledge, reviewing evidence, coordinating work and following development.',
      'Seven interactive demos cover Government, Research, Education, Talent, Leadership, Community and Clinical, each with its own workspaces and fictional records. Education, Talent, Leadership and Community share the framework’s development workflow; Research and Clinical use SKP without requiring CJI or NCJI assessment.',
      'The current demonstrations run in a web browser. Production deployment options, integrations and any installable applications remain part of product development.',
    ],
    note: '',
  },
]

export const systemRoles = [
  { name: 'Semantic Knowledge Platform (SKP)', role: 'Connects and governs knowledge, sources, concepts, and relationships.' },
  { name: 'Human Capability Framework', role: 'Defines assessment and development through CJI and NCJI.' },
  { name: 'Noetivra', role: 'Makes these resources accessible through a visual, interactive workspace.' },
]

export const workTogetherExamples = [
  {
    who: 'For an employer',
    body: 'Connecting role requirements to structured interview questions, work samples, and documented candidate responses.',
  },
  {
    who: 'For a researcher',
    body: 'Comparing findings, examining supporting passages, and recording unresolved questions.',
  },
  {
    who: 'For someone developing their capabilities',
    body: 'Completing an assessment, understanding the findings, following a development pathway, and reviewing progress over time.',
  },
]

export const approach = [
  {
    title: 'Connect ideas',
    body: 'Organize concepts, sources, and relationships so knowledge can move across documents, disciplines, and institutions.',
  },
  {
    title: 'Develop capability',
    body: 'Support stronger reasoning and judgment through clear feedback, practical development pathways, and reassessment.',
  },
  {
    title: 'Make knowledge usable',
    body: 'Bring approved knowledge into the interviews, assessments, research, and decisions where it can help.',
  },
  {
    title: 'Keep decisions reviewable',
    body: 'Make consequential findings understandable and open to human review, correction, appeal, and reassessment.',
  },
  {
    title: 'Learn and improve',
    body: 'Use reviewed outcomes to refine knowledge, assessment methods, and the applications built upon them.',
  },
]
